import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle, Clock } from "lucide-react";
import { SERVICES, IMAGES, WHATSAPP_URL } from "../data/site";

export default function Services() {
    const items = SERVICES.filter((s) => !s.hiddenFromGrid);
    return (
        <section
            id="hizmetler"
            data-testid="services-section"
            className="section bg-[#0a0a0c] gold-glow"
        >
            <div className="container-x relative">
                <div className="text-center max-w-2xl mx-auto mb-14 md:mb-20">
                    <div className="eyebrow mb-4">Hizmetlerimiz</div>
                    <h2 className="h2 text-[#f4efe4]">
                        Profesyonel <span className="gold-text">Masaj</span>{" "}
                        Hizmetlerimiz
                    </h2>
                    <div className="divider-gold mt-6 mx-auto" />
                    <p className="mt-6 body-base">
                        İhtiyacınıza uygun masaj uygulamasını seçin, kolayca
                        randevunuzu oluşturun.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                    {items.map((s) => (
                        <article
                            key={s.slug}
                            className="card flex flex-col group"
                            data-testid={`service-card-${s.slug}`}
                        >
                            <div className="relative aspect-[4/3] overflow-hidden bg-[#14141a]">
                                <img
                                    src={IMAGES[s.image]}
                                    alt={`${s.seoTitle} - Cegu Masaj Salonu`}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c] via-transparent to-transparent opacity-70" />
                                <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-[#0a0a0c]/80 backdrop-blur-md border border-[#c9a24b]/30 rounded-full px-3 py-1 text-[11px] text-[#f5d685] font-medium">
                                    <Clock className="w-3 h-3" />
                                    {s.duration}
                                </div>
                                <div className="absolute bottom-4 left-4 right-4">
                                    <h3 className="h3 text-[#f4efe4] leading-tight">
                                        {s.title}
                                    </h3>
                                </div>
                            </div>

                            <div className="p-5 md:p-6 flex flex-col flex-1">
                                <p className="text-[13.5px] leading-relaxed text-[#b8b1a1] flex-1">
                                    {s.short}
                                </p>

                                <div className="mt-5 flex items-center gap-2">
                                    <Link
                                        to={`/hizmet/${s.slug}`}
                                        data-testid={`service-detail-${s.slug}`}
                                        className="btn btn-ghost !text-[12px] !py-2 !px-3 !min-h-0 flex-1"
                                    >
                                        Detaylar
                                        <ArrowRight className="w-3.5 h-3.5" />
                                    </Link>
                                    <a
                                        href={WHATSAPP_URL}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-testid={`service-book-${s.slug}`}
                                        className="btn btn-gold !text-[12px] !py-2 !px-3 !min-h-0 flex-1"
                                    >
                                        <MessageCircle className="w-3.5 h-3.5" />
                                        Randevu
                                    </a>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
